import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MaterialModule } from '../material.module';

// Components
import { ErrorDialogComponent } from "./error-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MaterialModule
    ],
    declarations: [
        ErrorDialogComponent
    ],
    exports: [
        ErrorDialogComponent
    ],
    entryComponents: [
        ErrorDialogComponent
    ],
    providers: []
})
export class ErrorDialogModule { }